@if (state) {
  <p-button [label]="utilitiesService.getLocalisedValue(state)" [disabled]="disabled" (click)="toggleMenu(menu, $event)"
    [severity]="state.severity" icon="fa fa-solid fa-chevron-down" iconPos="right" >
  </p-button>
}

<p-menu #menu [popup]="true" [model]="transitionItems" appendTo="body"></p-menu>
